import { Gauge } from "@/features/gauge/Gauge";
import { SummaryTable } from "@/features/summary/SummaryTable";
import { PremiumLeadsCard } from "@/features/analytics/PremiumLeadsCard";
import { StaffTables } from "@/features/staff/StaffTables";
import { JR2Dialog } from "@/features/messages/JR2Dialog";

export function WallboardPage() {
  return (
    <div className="p-2 text-white text-left flex">
      <aside className="w-1/4">
        <Gauge />
        <SummaryTable />
        <PremiumLeadsCard />
      </aside>
      <StaffTables />
      <JR2Dialog />
    </div>
  );
}
